import React, { Component } from 'react';

class Articles extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sunumlar: []
        }
    }

    componentDidMount() {
        var uid = localStorage.getItem('uid');
  		console.log(uid);

        var VariablesAPI = 'https://api.recordatifocus.com/eskiler/'+ uid;
        fetch(VariablesAPI)
            .then(response => response.json())
            .then(data => this.setState({ sunumlar: data }));
    }

    render() {
        const { sunumlar } = this.state;
        return (
        <div>
            <div className="page-title">Sunum Listesi</div>
            {sunumlar.map(article =>
                <div className="article_item" key={article.title}>
                    <br/>
                    <div className="articletitle"><span>ID :</span> {article.title}</div>
                    <div className="articleinfo"><span>Tarih :</span> {article.created}</div>
                </div>
            )}
        </div>
        );
    }
}
export default Articles



// WEBPACK FOOTER //
// src/components/articles.jsx